export const transformResponsePerformanceInsightsAvailability = availability => {
  return {
    data_available_from: availability.data_available_from,
    has_sales: availability.has_sales,
  }
}
